import { render, staticRenderFns } from "./icon-angle-up-mini.vue?vue&type=template&id=2df115fe&scoped=true&"
var script = {}
import style0 from "./icon-angle-up-mini.vue?vue&type=style&index=0&id=2df115fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df115fe",
  null
  
)

export default component.exports